import { Navigate } from "react-router-dom";
import { hasLiftSession } from "./services/liftSession";

// Todo lo que cuelgue de /montacargas fuera del login exige sesión (JWT)
// vigente; sin ella, de vuelta al login. El JWT en sí lo revalida el
// backend en cada request (ver liftApi.js: 401 -> limpia la sesión).
function RequireLiftSession({ children }) {
  if (!hasLiftSession()) {
    return <Navigate to="/montacargas" replace />;
  }

  return children;
}

export default RequireLiftSession;
